const HIDDEN_PROJECT_STATES = ["canceled", "closed"]
// Shipped work stays reachable, just out of the way until someone searches for it.
const SEARCH_ONLY_PROJECT_STATES = ["completed"]

export function isSelectableProject(
	project: {
		state?: string | null
		linearTeamIds?: ReadonlyArray<string> | null
	},
	selectedTeamIds: ReadonlyArray<string>,
	searchQuery = "",
): boolean {
	if (project.state && HIDDEN_PROJECT_STATES.includes(project.state)) {
		return false
	}
	if (
		project.state &&
		SEARCH_ONLY_PROJECT_STATES.includes(project.state) &&
		!searchQuery.trim()
	) {
		return false
	}
	return !!project.linearTeamIds?.some((teamId) =>
		selectedTeamIds.includes(teamId),
	)
}
